import { render, staticRenderFns } from "./FormDocuments.vue?vue&type=template&id=0ea0ba5f&scoped=true&lang=pug&"
import script from "./FormDocuments.vue?vue&type=script&lang=js&"
export * from "./FormDocuments.vue?vue&type=script&lang=js&"
import style0 from "./FormDocuments.vue?vue&type=style&index=0&id=0ea0ba5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea0ba5f",
  null
  
)

export default component.exports